import React, { FocusEvent } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, CollectionServerUser } from "@preveil-api";
import { CheckboxStates, DriveUIActionTypes } from "src/common";
import { Checkbox } from "src/components";

type AllProps = {
    user: CollectionServerUser;
    selected: boolean;
    handleAction: ActionHandlerFunction;
};

// Description: This component is used to render the row of the list of users in the data export get started page
function ListRowComponent(props: AllProps) {
    const { user, handleAction, selected } = props;

    return <Row>
        <Col md="1">
            <Checkbox
                className="sr-only"
                onChange={(e: FocusEvent<HTMLInputElement>) => { handleAction({ actionType: DriveUIActionTypes.Select, params: { selected: e.target.checked, user } }); }}
                selected={selected ? CheckboxStates.checked : CheckboxStates.empty}
                value="all" label="Select All" />
        </Col>
        <Col md="3" className="col">{user.display_name}</Col>
        <Col md="3">{user.user_id}</Col>
        <Col md="3">{user.entity_metadata.department}</Col>
    </Row>;
}

export default React.memo(ListRowComponent);
